import React from 'react';
import styles from './ResultsModal.module.scss';

function ResultsModal(props) {
  return (
    <div className={
      styles.resultsModal + ' ' + (props.open ? styles.open : '')
    }>
      {/* Modal Header */}
      <div className={styles.header}>
        <h2>About Solport Studios</h2>
        <button className={styles.closeButton} onClick={props.onClose}>×</button>
      </div>
      
      {/* Scrollable Content Area */}
      <div className={styles.modalContent}>
        {/* Thesis Section */}
        <div className={styles.section}>
          <h3>Thesis</h3>
          <div className={styles.content}>
            <p className={styles.text}>
              SocialFi and tokenized gaming are unlocking the next frontier of gamified digital experiences, blending play with value in revolutionary ways where finance and community converge.
            </p>
          </div>
        </div>
        
        {/* About Section */}
        <div className={styles.section}>
          <h3>About</h3>
          <div className={styles.content}>
            <p className={styles.text}>
              Solport Studios builds immersive blockchain games where play, community, and value converge.
            </p>
          </div>
        </div>
        
        {/* Social Links Section */}
        <div className={styles.socialSection}>
          <h3>Connect</h3>
          <div className={styles.socialLinks}>
            <a 
              href="https://x.com/spaceportstudios" 
              target="_blank" 
              rel="noopener noreferrer" 
              className={styles.socialLink}
              aria-label="Follow us on X"
            >
              <div className={styles.socialIcon}>
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </div>
              <span>X.com</span>
            </a>
            
            <a 
              href="/docs" 
              className={styles.socialLink}
              aria-label="View Documentation"
            >
              <div className={styles.socialIcon}>
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                </svg>
              </div>
              <span>Documentation</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResultsModal;

